import { VARIANT_TABLE_SET_ACCESSORIES_PANEL_OPEN, VARIANT_TABLE_SET_QUERY_PARAMS, VARIANT_TABLE_SET_STATE } from '../constants';
const params = new URLSearchParams(window.location.search);
const entries = Array.from(params.entries());
let paramsEntries = Object.fromEntries(entries);
const defaultState = {
    accessoryOpen: null,
    queryParams: paramsEntries || {}
};
export const variantTable = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case VARIANT_TABLE_SET_STATE:
            return { ...state, ...payload };
        case VARIANT_TABLE_SET_QUERY_PARAMS:
            return { ...state, queryParams: payload };
        case VARIANT_TABLE_SET_ACCESSORIES_PANEL_OPEN:
            return { ...state, accessoryOpen: payload.id };
        default:
            return state;
    }
};
